import { NameAndSourceId } from "@common/types/server-list-types";
import { Timeseries } from "@src/types/timeseries";

const toNodePath = (
  parentNames: string[] | undefined,
): string[] | undefined => {
  if (!parentNames) return undefined;
  const filtered = parentNames.filter((name) => name !== "Root");
  return filtered.length > 0 ? filtered : undefined;
};

/**
 * Maps a machine's active timeseries to dropdown options, keeping only nodes a
 * gauge can consume: `data_type === "numeric"`. Shows the node's `source` (its
 * id) when `name` is null (B9 not wired yet: names/units are null).
 */
export const toNumericNodeOptions = (
  timeseries: Record<string, Timeseries>,
): NameAndSourceId[] =>
  Object.values(timeseries)
    .filter((t) => t.data_type === "numeric")
    .map((t) => ({
      name: t.name ?? t.source,
      source_id: t.source,
      nodePath: toNodePath(t.node_path?.parent_names),
    }));

export const toNumericAndStringNodeOptions = (
  timeseries: Record<string, Timeseries>,
): NameAndSourceId[] =>
  Object.values(timeseries)
    .filter((t) => t.data_type === "numeric" || t.data_type === "string")
    .map((t) => ({
      name: t.name ?? t.source,
      source_id: t.source,
      nodePath: toNodePath(t.node_path?.parent_names),
    }));

export const getNumericNodeUnit = (
  timeseries: Record<string, Timeseries>,
  sourceId: string,
): number | null =>
  Object.values(timeseries).find(
    (timeseriesItem) =>
      timeseriesItem.data_type === "numeric" &&
      timeseriesItem.source === sourceId,
  )?.unit ?? null;
